export default {
	title: "Wisdom Quotes",
	text: "Quote",
	author: "Author",
	isActive: "Active",
	create: "New Quote",
	edit: "Edit Quote",
	searchPlaceholder: "Search quotes...",
	noData: "No quotes registered",
	noDataSubtext: "Add custom wisdom quotes for your temple",
	confirmDeleteMessage: "Are you sure you want to delete this quote? This action cannot be undone.",
	stats: {
		total: "Total",
		active: "Active",
	},
	form: {
		text: "Quote",
		author: "Author",
	},
	validation: {
		textMaxLength: "The quote must have at most 500 characters",
		authorMaxLength: "The author must have at most 150 characters",
	},
	systemQuotes: "System",
	customQuotes: "Custom",
	weightHint: "Adjust how often each type of quote appears on the dashboard",
	messages: {
		createSuccess: "Quote created successfully",
		updateSuccess: "Quote updated successfully",
		deleteSuccess: "Quote deleted successfully",
		createError: "Error creating quote",
		updateError: "Error updating quote",
		deleteError: "Error deleting quote",
		loadError: "Error loading quotes",
		weightSaved: "Quote proportion saved",
		weightError: "Error saving proportion",
	},
};
